import SeoWrapper from './seo-wrapper';

export default SeoWrapper;
